import DatetimeUtils from "../../../gd/utils/datetime-utils"
import {Cover} from "./cover"
import TaskViewLinks from "../../link/task-view-links";

// WOW - wait a sec zopa
// ya delal properties = cache data dlya expenses a tut okazivaetsya uze est' properties ....
// stremno konechno ... nado budet podumat' chto s etim govnom delat'
// poka poprobuu i to i to

export type TicketView = {
    enabled                                    : boolean
    originalTicketModuleEncodedProjectId       : string | null
    crmContacts                                : {[crmContactId: string]: string}
}

export class TaskProperties {

    public myWork           : any
    public expensesTotal?   : number
    public cover?           : Cover
    public links            : TaskViewLinks | null
    public ticketView       : TicketView

    constructor(data:any) {

        this.myWork         = {
            actionRequired  : {
                fromUserId      : _.get(data,'myWork.actionRequired.fromUserId', null),
                isNew           : _.get(data,'myWork.actionRequired.isNew', false),
                sinceMoment     : DatetimeUtils.datetimeToMoment(_.get(data,'myWork.actionRequired.sinceMoment')),
            },
            assigned    : {
                fromUserId      : _.get(data,'myWork.assigned.fromUserId'),
                sinceMoment     : DatetimeUtils.datetimeToMoment(_.get(data,'myWork.assigned.sinceMoment')),  // (s kakogo moment teckuchii user assigned)
            },
            deadline    : {
                fromUserId      : _.get(data,'myWork.deadline.fromUserId'),
                sinceMoment     : DatetimeUtils.datetimeToMoment(_.get(data,'myWork.deadline.sinceMoment')),  // (s kakogo moment teckuchii user poluchil deadline)
            },
        }

        this.expensesTotal      = _.get(data,'expensesTotal', undefined)

        const cover             = _.get(data,'cover', undefined)
        if (cover) this.cover   = new Cover(cover)

        const links             = _.get(data, "links", null)

        this.links              = !!links ? new TaskViewLinks(links) : null

        this.ticketView         = {
            enabled                                 : !!_.get(data, "ticketView.enabled"),
            originalTicketModuleEncodedProjectId    : _.get(data, "ticketView.originalTicketModuleEncodedProjectId", null),
            crmContacts                             : _.get(data, "ticketView.crmContacts", {})
        }
    }


    toJSON() {
        // tut nado mega akkuyratno vse delat' esli ne null to sohranyaem
        // esli null to net ... tipo default !!!
        // koroche mnogo code no poka ne nuzno

        const omitDefault = (data:any) => _.omitBy(data, value=>!value)

        const result = omitDefault({
            myWork: omitDefault({
                actionRequired  : omitDefault(this.myWork.actionRequired),
                assigned        : omitDefault(this.myWork.assigned),
                deadline        : omitDefault(this.myWork.deadline)
            })
        })

        if (this.expensesTotal) {
            result.expensesTotal    = this.expensesTotal
        }

        if (this.cover) {
            result.cover            = this.cover.toJSON()
        }

        result.links                = !!this.links ? this.links.toJSON() : null

        return result
    }
}
